/* ==========================================================================
   OliveDrab — product page

   Variant switching (price, stock, SKU, gallery, URL), add to cart, quantity,
   share, the size chart drawer and the pincode field.

   The picker is built from real radio inputs inside the product form, so with
   JavaScript off the form still posts a valid variant. Everything here is an
   enhancement on top of that.

   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.ODConfig || {};
  var strings = cfg.strings || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function reduced() {
    return window.OD && window.OD.prefersReduced ? window.OD.prefersReduced() : false;
  }

  function setup(root) {
    if (root.dataset.odPdpBound) return;
    root.dataset.odPdpBound = '1';

    var variantsEl = $('[data-od-variant-data]', root);
    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { variants = []; }
    }

    var form = $('[data-od-variant-input]', root);
    var addBtn = $('[data-od-add]', root);
    var addText = $('[data-od-add-text]', root);
    var addSpin = $('.od-pdp__add-spin', root);
    var addError = $('[data-od-add-error]', root);
    var priceEl = $('[data-od-price]', root);
    var stockEl = $('[data-od-stock]', root);
    var skuEl = $('[data-od-sku]', root);
    var eyebrow = $('[data-od-eyebrow]', root);
    // the was price and the discount badge only appear when OD 07 allows them
    var showCompare = root.dataset.showCompare === 'true';

    /* --------------------------------------------------- variant logic */

    function selectedValues() {
      var out = [];
      $$('.od-variants__group', root).forEach(function (group) {
        var i = parseInt(group.dataset.odOptionIndex, 10);
        var checked = $('input[type="radio"]:checked', group);
        if (checked) { out[i] = checked.value; return; }
        var sel = $('select', group);
        if (sel) out[i] = sel.value;
      });
      return out;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] == null) continue;
          if (v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // mark option values that cannot be reached given the other choices
    function refreshAvailability(values) {
      $$('.od-variants__group', root).forEach(function (group) {
        var gi = parseInt(group.dataset.odOptionIndex, 10);
        $$('input[type="radio"]', group).forEach(function (input) {
          var probe = values.slice();
          probe[gi] = input.value;

          var reachable = variants.some(function (v) {
            if (!v.available) return false;
            for (var j = 0; j < probe.length; j++) {
              if (j === gi) { if (v.options[j] !== input.value) return false; continue; }
              if (probe[j] != null && v.options[j] !== probe[j]) return false;
            }
            return true;
          });

          var label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !reachable);
          input.setAttribute('data-unavailable', String(!reachable));
        });
      });
    }

    function money(cents) {
      if (window.Shopify && Shopify.formatMoney && cfg.money && cfg.money.format) {
        try { return Shopify.formatMoney(cents, cfg.money.format); } catch (e) {}
      }
      return null;
    }

    function update() {
      var values = selectedValues();
      var v = findVariant(values);

      refreshAvailability(values);

      // reflect the chosen value beside each option name
      // using the short size label when the option carries one
      $$('[data-od-chosen]', root).forEach(function (el) {
        var i = parseInt(el.dataset.odChosen, 10);
        if (!values[i]) return;
        var group = el.closest('.od-variants__group');
        var checked = group && $('input[type="radio"]:checked', group);
        var sel = group && $('select', group);
        var label = checked && checked.dataset.odLabel;
        if (!label && sel && sel.selectedOptions && sel.selectedOptions[0]) label = sel.selectedOptions[0].dataset.odLabel;
        el.textContent = label || values[i];
      });

      if (!v) {
        if (addBtn) {
          addBtn.disabled = true;
          if (addText) addText.textContent = strings.unavailable || 'Unavailable';
        }
        if (form) form.disabled = true;
        return;
      }

      if (form) {
        form.value = v.id;
        form.disabled = !v.available;
      }

      // price, rendered from the Liquid-formatted strings in the variant data
      if (priceEl) {
        var now = priceEl.querySelector('.od-pdp__now');
        var was = priceEl.querySelector('.od-pdp__was');
        var onSale = showCompare && v.compare_at && v.compare_at > v.price;

        if (now) {
          now.textContent = v.price_formatted || money(v.price) || now.textContent;
          now.classList.toggle('is-sale', !!onSale);
        }
        if (onSale) {
          if (!was) {
            was = document.createElement('s');
            was.className = 'od-pdp__was';
            priceEl.insertBefore(was, priceEl.firstChild);
          }
          was.textContent = v.compare_at_formatted || money(v.compare_at) || '';
          was.hidden = false;
        } else if (was) {
          was.hidden = true;
        }

        if (eyebrow && onSale) {
          var pct = Math.round(((v.compare_at - v.price) / v.compare_at) * 100);
          if (pct > 0) eyebrow.textContent = pct + '% off';
        }
      }

      // stock
      if (stockEl) {
        var low = parseInt(root.dataset.lowstock, 10) || 3;
        if (!v.available) {
          stockEl.innerHTML = '';
        } else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
          stockEl.innerHTML = '<span class="od-pdp__stock-dot od-pdp__stock-dot--low" aria-hidden="true"></span>' +
                              'Only ' + v.inventory_quantity + ' left';
        } else {
          stockEl.innerHTML = '<span class="od-pdp__stock-dot" aria-hidden="true"></span>In stock';
        }
      }

      if (skuEl) skuEl.textContent = v.sku ? 'Ref. ' + v.sku : '';

      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addText) {
          addText.textContent = v.available
            ? (strings.addToCart || 'Add to bag')
            : (strings.soldOut || 'Sold out');
        }
      }

      // bring the variant's own image into view
      if (v.featured_media_index != null && window.OD && window.OD.gallery) {
        window.OD.gallery.goTo(v.featured_media_index, { instant: true });
      }

      // keep the URL shareable without adding a history entry per click
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    $$('.od-variants__input, [data-od-option-select]', root).forEach(function (el) {
      el.addEventListener('change', update);
    });

    // run once so availability marks are correct on load
    if (variants.length) {
      try { update(); } catch (e) {}
    }

    /* ------------------------------------------------------- quantity */

    var qtyInput = $('[data-od-qty-input]', root);
    $$('[data-od-qty]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.dataset.odQty, 10) || 0;
        var next = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.value = Math.max(1, next);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ----------------------------------------------------- add to cart */

    var productForm = $('.od-pdp__form', root);
    if (productForm && addBtn) {
      productForm.addEventListener('submit', function (e) {
        // let the browser handle it if fetch is unavailable
        if (!window.fetch) return;
        e.preventDefault();

        if (addError) { addError.hidden = true; addError.textContent = ''; }

        var values = selectedValues();
        var v = findVariant(values);
        if (!v) {
          if (addError) {
            addError.textContent = strings.selectSize || 'Please choose an option';
            addError.hidden = false;
          }
          return;
        }

        addBtn.classList.add('is-busy');
        addBtn.disabled = true;
        if (addSpin) addSpin.hidden = false;

        var body = new FormData(productForm);
        body.set('id', v.id);

        fetch((cfg.routes && cfg.routes.cartAdd) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: body
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
              return data;
            });
          })
          .then(function (data) {
            // cart drawer hook: announce the add so the drawer can open with its own note
            document.dispatchEvent(new CustomEvent('od:cart:added', { detail: { items: (data && data.items) || [data], source: 'product' } }));
            var drawerSpeaks = window.OD && window.OD.cartDrawerActive;
            if (!drawerSpeaks && window.OD && window.OD.toast) window.OD.toast(strings.added || 'Added to bag');
            if (window.OD && window.OD.refreshCart) window.OD.refreshCart();
            document.dispatchEvent(new CustomEvent('od:cart:changed'));
          })
          .catch(function (err) {
            if (addError) {
              addError.textContent = (err && err.message) || strings.error || 'Something went wrong';
              addError.hidden = false;
            }
          })
          .then(function () {
            addBtn.classList.remove('is-busy');
            addBtn.disabled = false;
            if (addSpin) addSpin.hidden = true;
          });
      });
    }

    /* ---------------------------------------------------------- share */

    $$('[data-od-share]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var data = { title: btn.dataset.title, url: btn.dataset.url };
        if (navigator.share) {
          navigator.share(data).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(data.url).then(function () {
            if (window.OD && window.OD.toast) window.OD.toast('Link copied');
          }).catch(function () {});
        }
      });
    });

    /* -------------------------------------------------------- pincode */

    var pin = $('[data-od-pincode]', root);
    if (pin) {
      var input = $('[data-od-pincode-input]', pin);
      var btn = $('[data-od-pincode-check]', pin);
      var out = $('[data-od-pincode-out]', pin);

      function check() {
        var value = (input.value || '').trim();
        out.classList.remove('is-ok', 'is-bad');

        if (!/^[1-9][0-9]{5}$/.test(value)) {
          out.textContent = 'Enter a valid 6 digit pincode.';
          out.classList.add('is-bad');
          return;
        }

        var min = parseInt(root.dataset.shipMin, 10) || 3;
        var max = parseInt(root.dataset.shipMax, 10) || 7;
        var fmt = function (days) {
          var d = new Date();
          d.setDate(d.getDate() + days);
          return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
        };
        out.textContent = 'Estimated delivery to ' + value + ': ' + fmt(min) + ' – ' + fmt(max) + '.';
        out.classList.add('is-ok');
      }

      if (btn) btn.addEventListener('click', check);
      if (input) {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); check(); }
        });
      }
    }

    /* ----------------------------------------------------- size chart */

    /* ------------------------------------------- size guide dropdown */

    var guide = $('[data-od-size-guide]', root);
    $$('[data-od-size-guide-open]', root).forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!guide) return;
        e.preventDefault();
        guide.open = true;
        guide.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'nearest' });
        var summary = $('summary', guide);
        if (summary) summary.focus({ preventScroll: true });
      });
    });

    // inch / centimetre toggle inside the dropdown
    $$('[data-od-size-chart-inline]', root).forEach(function (box) {
      $$('[data-od-units]', box).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.dataset.odUnits;
          $$('[data-od-units]', box).forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', String(on));
          });
          $$('[data-od-chart-table] td[data-in]', box).forEach(function (td) {
            var inches = parseFloat(td.getAttribute('data-in'));
            if (isNaN(inches)) { td.textContent = td.getAttribute('data-in'); return; }
            td.textContent = unit === 'cm' ? (inches * 2.54).toFixed(1) : td.getAttribute('data-in');
          });
        });
      });
    });

    var chart = $('[data-od-size-chart]');
    if (chart) {
      var panel = $('.od-sizechart__panel', chart);
      var release = null;
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        chart.hidden = false;
        requestAnimationFrame(function () { chart.classList.add('is-open'); });
        if (window.OD && window.OD.lockScroll) window.OD.lockScroll();
        if (window.OD && window.OD.focusTrap) release = window.OD.focusTrap(panel, close);
        var c = $('[data-od-size-chart-close]', chart);
        if (c) setTimeout(function () { c.focus(); }, 60);
      }

      function close() {
        chart.classList.remove('is-open');
        if (window.OD && window.OD.unlockScroll) window.OD.unlockScroll();
        if (release) { release(); release = null; }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        setTimeout(function () {
          if (!chart.classList.contains('is-open')) chart.hidden = true;
        }, reduced() ? 0 : 420);
      }

      $$('[data-od-size-chart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
      $$('[data-od-size-chart-close]', chart).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); close(); });
      });

      // inch / centimetre toggle, converted from the inch values in the table
      $$('[data-od-units]', chart).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.dataset.odUnits;
          $$('[data-od-units]', chart).forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', String(on));
          });
          $$('[data-od-chart-table] td[data-in]', chart).forEach(function (td) {
            var inches = parseFloat(td.getAttribute('data-in'));
            if (isNaN(inches)) { td.textContent = td.getAttribute('data-in'); return; }
            td.textContent = unit === 'cm'
              ? (inches * 2.54).toFixed(1)
              : td.getAttribute('data-in');
          });
        });
      });
    }
  }

  /* The buy panel has no scroller of its own. When it is taller than the
     screen, its sticky top is pulled up by the difference, so it scrolls with
     the page until its last line is showing and then holds. It is measured
     again whenever its height changes, such as a dropdown opening. */
  function stickyPanel(root) {
    var panel = $('[data-od-sticky-panel]', root);
    if (!panel || panel.dataset.odPanelBound) return;
    panel.dataset.odPanelBound = '1';

    function place() {
      var header = document.querySelector('od-header');
      var headH = header ? header.getBoundingClientRect().height : 0;
      var gap = 24;
      var fits = window.innerHeight - headH - gap * 2;
      var top = panel.offsetHeight <= fits
        ? headH + gap
        : window.innerHeight - panel.offsetHeight - gap;
      panel.style.setProperty('--od-panel-top', Math.round(top) + 'px');
    }

    place();
    window.addEventListener('resize', place, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(panel);
  }

  function init(ctx) {
    $$('[data-od-product]', ctx || document).forEach(function (root) {
      try { setup(root); } catch (e) {
        if (window.console && console.warn) console.warn('[OD product]', e);
      }
      try { stickyPanel(root); } catch (e) { /* the panel still reads without it */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
